<div class="common-layout {{ 'is-' + selectedHeaderColor }}" [ngClass]="{
        'is-folded': isFolded,
        'is-side-nav-dark' : isSideNavDark,
        'is-expand' : isExpand
    }">
    <app-header></app-header>
    <app-sidenav></app-sidenav>
    <div class="page-container">
        <div class="main-content">
            <div class="main-content-header" *ngIf="contentHeaderDisplay !== 'none'">
                <h4 class="page-title" style="margin-right: 10px; color: #A1A5B7;" (click)="back()">
                    <span class="back">Trở về </span>
                    <span>•</span>
                </h4>
                <div class="d-flex" *ngIf="breadcrumbs$ | async; let breadcrumbs">
                    <h4 class="page-title" *ngFor="let breadcrumb of breadcrumbs">
                        {{(breadcrumb.label)}}
                    </h4>
                </div>
            </div>
            <router-outlet></router-outlet>
            <router-outlet name="popup"></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>